import { render } from "./RequestResetPasswordByEmail.vue?vue&type=template&id=371bd484&scoped=true"
import script from "./RequestResetPasswordByEmail.vue?vue&type=script&lang=js"
export * from "./RequestResetPasswordByEmail.vue?vue&type=script&lang=js"

import "./RequestResetPasswordByEmail.vue?vue&type=style&index=0&id=371bd484&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371bd484"]])

export default __exports__